import { Summary } from "../components/summary/Summary";
import { Particulars } from "../components/tab-sections/Particulars";
import { NotableItems } from "../components/NotableItems";
import { Grading } from "../components/tab-sections/Grading";
import { Documents } from "../components/tab-sections/Documents";
import { GradeComparison } from "../components/tab-sections/GradeComparison";
import { VesselInspectionDataResponse } from "../types/responses/VesselInspectionDataResponse";
import { Defects } from "../components/Defects";
import { Decarbonisation } from "../components/tab-sections/Decarbonisation";
import { AdjustedGrading } from "../components/tab-sections/AdjustedGrading";
import { hasAdjustedGradingSupplement } from "../utils/DocumentHelpers";
import { APIGrade } from "@idwal/idwal-react-components/dist/types/APIGrade";

const getIdTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData}/>
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.grade_comparison"),
            content: (
                <GradeComparison
                    imo={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.IMONumber
                    }
                    vesselGrade={
                        {grade: vesselInspectionDataResponse.vesselInspectionResponse?.Grade} as APIGrade
                    }
                />
            )
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={true} />
        },
        {
            title: t("tabs.defects"),
            content: <Defects />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={7} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        }
    ];
};

const getDefaultTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData} />
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.notable_items"),
            content: <NotableItems />
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={false} />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={6} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        },
        {
            title: t("tabs.grade_comparison"),
            content: (
                <GradeComparison
                    imo={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.IMONumber
                    }
                    vesselGrade={
                        {grade: vesselInspectionDataResponse.vesselInspectionResponse?.Grade} as APIGrade
                    }
                />
            )
        }
    ];
};

const getConditionInspectionTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData}/>
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.notable_items"),
            content: <NotableItems />
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={false} />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={6} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        }
    ];
};

export const getTabsForInspection = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    const vesselInspectionResponse =
        vesselInspectionDataResponse.vesselInspectionResponse;
    if (vesselInspectionResponse == undefined) {
        return [];
    }

    let tabs = [];

    switch (vesselInspectionResponse.InspectionType) {
        case "ID Condition Inspection":
            tabs = getIdTabs(vesselInspectionDataResponse, documentData, t);
            break;
        case "Condition Inspection":
            tabs = getConditionInspectionTabs(vesselInspectionDataResponse, documentData, t);
            break;
        default:
            tabs = getDefaultTabs(vesselInspectionDataResponse, documentData, t);
            break;
    }

    if (hasAdjustedGradingSupplement(documentData?.documents)) {
        tabs.push({
            title: t("tabs.adjusted_grading"),
            content: <AdjustedGrading />
        });
    }

    return tabs;
};
